export default __webpack_public_path__ + "static/media/profile.5563cea1.svg";